import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Star, Download, Play } from "lucide-react";
export const ProductCatalog = () => {
  const elitePrecisionProducts = [{
    id: 1,
    name: "Elite Precision Pro",
    image: "/images/disque_elite_precision_1.jpeg",
    description: "Disque diamanté ultra-précis pour carrelage haut de gamme",
    features: ["Coupe extra-fine 1,1 mm", "Segments superthin", "Grès cérame pleine masse"],
    price: "À partir de 89€",
    category: "Carrelage"
  }, {
    id: 2,
    name: "Elite Precision Standard",
    image: "/images/disque_elite_precision_2.jpeg",
    description: "Solution polyvalente pour tous types de carrelage",
    features: ["Coupe nette", "Moins d'écaillage", "Faïence et marbre"],
    price: "À partir de 65€",
    category: "Carrelage"
  }, {
    id: 3,
    name: "Elite Precision Biseau",
    image: "/images/disque_elite_precision_4.jpeg",
    description: "Spécialisé pour les coupes en biseau 45°",
    features: ["Biseau parfait", "Finition professionnelle", "Nid d'abeille"],
    price: "À partir de 95€",
    category: "Carrelage"
  }];
  const eliteProProducts = [{
    id: 4,
    name: "ElitePro Béton",
    image: "/images/disque_elitepro_1.jpeg",
    description: "Disque haute performance pour béton et maçonnerie",
    features: ["Béton armé", "Matériaux durs", "Longue durée de vie"],
    price: "À partir de 75€",
    category: "Maçonnerie"
  }, {
    id: 5,
    name: "ElitePro Universal",
    image: "/images/disque_elitepro_4.jpeg",
    description: "Solution universelle pour tous matériaux de construction",
    features: ["Multi-matériaux", "Coupe rapide", "Résistant"],
    price: "À partir de 85€",
    category: "Maçonnerie"
  }, {
    id: 6,
    name: "ElitePro Laser",
    image: "/images/disque_elitepro_3.jpeg",
    description: "Technologie laser pour une précision maximale",
    features: ["Précision laser", "Coupe propre", "Performance optimale"],
    price: "À partir de 110€",
    category: "Maçonnerie"
  }];
  return <section id="produits" className="py-20 bg-white scroll-mt-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Notre Gamme Professionnelle
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez nos deux gammes d'outils professionnels conçues spécifiquement 
            pour répondre aux besoins des carreleurs et des maçons.
          </p>
        </div>

        {/* Elite Precision - Carreleurs */}
        <div className="mb-16">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h3 className="text-3xl font-bold text-orange-500 mb-2">Elite Precision</h3>
              <p className="text-gray-600">Spécialement conçu pour les carreleurs professionnels</p>
            </div>
            <div className="flex items-center space-x-4">
              <Button variant="outline" className="flex items-center space-x-2">
                <Download className="h-4 w-4" />
                <span>Documentation</span>
              </Button>
              <Button variant="outline" className="flex items-center space-x-2">
                <Play className="h-4 w-4" />
                <span>Vidéo Démo</span>
              </Button>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {elitePrecisionProducts.map(product => <Card key={product.id} className="hover:shadow-lg transition-shadow">
                <CardHeader className="p-0">
                  <img src="https://static-us-img.skywork.ai/prod/user/head_picture/1983116382626562048_SLF30 Ø125 ELITE Précision.jpg?image_process=quality,q_90/resize,w_1280/format,webp" alt={product.name} className="w-full rounded-t-lg sk-edit-loading h-[192px] object-cover" />
                </CardHeader>
                <CardContent className="p-6">
                  <div className="flex justify-between items-start mb-2">
                    <CardTitle className="text-xl">{product.name}</CardTitle>
                    <Badge variant="secondary">{product.category}</Badge>
                  </div>
                  <CardDescription className="mb-4">
                    {product.description}
                  </CardDescription>
                  <ul className="space-y-1 mb-4">
                    {product.features.map((feature, index) => <li key={index} className="flex items-center text-sm text-gray-600">
                        <Star className="h-3 w-3 text-yellow-500 mr-2" />
                        {feature}
                      </li>)}
                  </ul>
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-bold text-orange-500">{product.price}</span>
                    <a href="#contact" className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                      Devis
                    </a>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>

        {/* ElitePro - Maçons */}
        <div>
          <div className="flex items-center justify-between mb-8">
            <div>
              <h3 className="text-3xl font-bold text-orange-600 mb-2">ElitePro</h3>
              <p className="text-gray-600">Solutions professionnelles pour les artisans maçons</p>
            </div>
            <div className="flex items-center space-x-4">
              <Button variant="outline" className="flex items-center space-x-2">
                <Download className="h-4 w-4" />
                <span>Documentation</span>
              </Button>
              <Button variant="outline" className="flex items-center space-x-2">
                <Play className="h-4 w-4" />
                <span>Vidéo Démo</span>
              </Button>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {eliteProProducts.map(product => <Card key={product.id} className="hover:shadow-lg transition-shadow">
                <CardHeader className="p-0">
                  <img src={product.image} alt={product.name} className="w-full h-48 object-cover rounded-t-lg" />
                </CardHeader>
                <CardContent className="p-6">
                  <div className="flex justify-between items-start mb-2">
                    <CardTitle className="text-xl">{product.name}</CardTitle>
                    <Badge variant="secondary">{product.category}</Badge>
                  </div>
                  <CardDescription className="mb-4">
                    {product.description}
                  </CardDescription>
                  <ul className="space-y-1 mb-4">
                    {product.features.map((feature, index) => <li key={index} className="flex items-center text-sm text-gray-600">
                        <Star className="h-3 w-3 text-yellow-500 mr-2" />
                        {feature}
                      </li>)}
                  </ul>
                  <div className="flex justify-between items-center">
                    <span className="text-lg font-bold text-orange-600">{product.price}</span>
                    <a href="#contact" className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                      Devis
                    </a>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
};